import { render } from "./GroupCreate.vue?vue&type=template&id=44f3c956"
import script from "./GroupCreate.vue?vue&type=script&lang=js"
export * from "./GroupCreate.vue?vue&type=script&lang=js"

import "./GroupCreate.vue?vue&type=style&index=0&id=44f3c956&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__